import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import { IconButton } from "@mui/material";
import BryxInput from "../BryxInput";
import BryxIcon from "../BryxIcon/BryxIcon";
import BryxColors from "../../types/theme";
const BryxDumbSearchBar = styled((props) => (_jsx(BryxInput, { sx: props.sx, inputRef: props.inputRef, className: props.className, value: props.value, onChange: props.onChange, placeholder: props.placeholder, autoFocus: props.autoFocus, InputProps: {
        startAdornment: (_jsx(BryxIcon, { sx: { fill: BryxColors.notify("light", "inactive"), marginRight: "8px" }, iconName: "search", smIconSize: true })),
        endAdornment: props.value != "" && (_jsx(IconButton, { disableRipple: true, onClick: props.onClear, style: { height: "21px", width: "21px" }, children: _jsx(BryxIcon, { sx: { fill: BryxColors.notify("light", "inactive") }, iconName: "close", smIconSize: true }) })),
    } })))(({ theme, value, customWidth, customHeight }) => {
    const pallete = theme.palette.mode;
    return {
        "& .MuiInputBase-root": {
            "& input::placeholder": {
                opacity: 1,
            },
            border: "solid 1px " + BryxColors.LightMode.specialColors.searchBarBackground,
            paddingRight: "8px",
            width: customWidth ? customWidth : "243px",
            height: customHeight ? customHeight : "34px",
            color: BryxColors.brand("dark", -2),
            backgroundColor: BryxColors.specialColor(pallete).searchBarBackground,
            "& svg[name=close_rounded]:hover": {
                "& *": {
                    fill: BryxColors.brand1(pallete) + " !important",
                },
                height: "21px !important",
                fontSize: "21px !important",
            },
            "&:hover": {
                "&:not(.Mui-focused)": {
                    border: "solid 1px " + BryxColors.LightMode.specialColors.searchBarBackground,
                    "& svg *": {
                        fill: value == "" ? BryxColors.brand1(pallete) : "",
                    },
                    "& input[type=text]::placeholder": {
                        color: BryxColors.brand1(pallete),
                    },
                },
            },
            "&.Mui-focused": {
                backgroundColor: "unset",
                border: "solid 1px",
                borderColor: BryxColors.brand4(pallete),
            },
        },
    };
});
export default BryxDumbSearchBar;
